<template>
  <components :is="el" class="animated-number" v-bind="$attrs" v-on="$listeners">
    <slot :value="animatedNumber">{{ animatedNumber }}</slot>
  </components>
</template>

<script>
import { gsap } from 'gsap';

const TRANSITION_TIME = 0.5;
const START_VALUE = 0;

export default {
  name: 'AnimatedNumber',

  props: {
    value: {
      type: Number,
      required: true,
    },

    startValue: {
      type: Number,
      default: START_VALUE,
    },

    el: {
      type: String,
      default: 'span',
    },

    decimals: {
      type: Number,
      default: 0,
    },

    triggerAnimation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      animatedValue: 0,
      timeline: null,
    };
  },

  computed: {
    animatedNumber() {
      return this.animatedValue.toFixed(this.decimals);
    },

    // hasSlot() {
    //   return !!this.$slots.default && !!this.$slots.default[0];
    // },
  },

  watch: {
    triggerAnimation(triggerAnimation) {
      if (triggerAnimation) this.animateNumber();
    },
  },

  mounted() {
    this.$watch('value', this.animateNumber, { immediate: true });
  },

  methods: {
    animateNumber() {
      if (this.timeline) this.timeline.pause();

      this.animatedValue = this.startValue;
      this.timeline = gsap.to(this, {
        duration: TRANSITION_TIME,
        animatedValue: this.value,
        roundProps: 'animatedValue',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.animated-number {
  // Enable numeric font-feature settings so all numbers have the same width and the animation doesn't jitter
  font-family: 'SAP-Numeric', SAP, $fallback-fonts;
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
}
</style>
